module.exports = __webpack_public_path__ + "img/sendgrid.37bb583a.png";